module.exports = __webpack_public_path__ + "static/the-pack-logo-black-b46584a2ab51541fe56116ae32c5b9ff.png";